import { SVGProps } from "react";

export default function UiLocationIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M12.5 2.25C8.35786 2.25 5 5.60786 5 9.75C5 12.5064 6.63914 15.2029 8.34418 17.2699C9.20633 18.315 10.0709 19.1817 10.7205 19.7869C11.0455 20.0897 11.3167 20.3273 11.5077 20.4892C11.6032 20.5702 11.6787 20.6323 11.7309 20.6746C11.757 20.6958 11.7773 20.712 11.7914 20.7232L11.808 20.7363L11.8127 20.74L11.8143 20.7412C12.2205 21.0538 12.7795 21.0538 13.1857 20.7412L13.192 20.7363L13.2086 20.7232C13.2227 20.712 13.243 20.6958 13.2691 20.6746C13.3213 20.6323 13.3968 20.5702 13.4923 20.4892C13.6833 20.3273 13.9545 20.0897 14.2795 19.7869C14.9291 19.1817 15.7937 18.315 16.6558 17.2699C18.3609 15.2029 20 12.5064 20 9.75C20 5.60786 16.6421 2.25 12.5 2.25ZM12.5 12C13.7426 12 14.75 10.9926 14.75 9.75C14.75 8.50736 13.7426 7.5 12.5 7.5C11.2574 7.5 10.25 8.50736 10.25 9.75C10.25 10.9926 11.2574 12 12.5 12Z"
        fill="#A0A0A9"
        fillRule="evenodd"
      />
    </svg>
  );
}
